import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { NotFound } from '@sorare/core/src/lib/routing';

import GenericChallengesPage from '@sorare/manager/src/components/challenges/ChallengesPage';
import { useEnableManagerProgression } from 'hooks/useEnableManagerProgression';

const ChallengesPage = () => {
  const enableManagerProgression = useEnableManagerProgression();

  if (enableManagerProgression) {
    return <GenericChallengesPage sport={Sport.NBA} />;
  }
  return <NotFound />;
};

export default ChallengesPage;
